export default __webpack_public_path__ + "static/O0167-821a052da19d5a870578a3d12f8df85a.png";